import { Field } from "@progress/kendo-react-form";
import type { KeyValue } from "@progress/kendo-react-form";
import * as React from "react";
import { Autocomplete, AutocompleteProps } from "../Autocomplete/Autocomplete";

export interface PortfolioStrategy {
  id: string;
  name: string;
}

interface IOwnProps extends Omit<AutocompleteProps, "name" | "label"> {
  errors: KeyValue<string>;
  name?: string;
  label?: string | null;
  allStrategies: PortfolioStrategy[] | undefined;
}

export const StrategyField = ({
  errors,
  name = "strategy",
  label = "Strategy",
  defaultValue,
  allStrategies,
  ...rest
}: IOwnProps) => {
  const [open, setOpen] = React.useState(false);

  const component = React.useMemo(
    () => (props: AutocompleteProps) =>
      (
        <Autocomplete
          {...props}
          opened={open}
          onOpen={() => setOpen(true)}
          onClose={() => setTimeout(() => setOpen(false), 200)}
          onFocus={() => setOpen(true)}
        />
      ),
    [open, setOpen]
  );

  const filterData = (filter?: string) => {
    const foundStrategies = allStrategies
      ?.filter((item: any) =>
        (item.name ?? "").toLowerCase().startsWith(filter?.toLowerCase() ?? "")
      )
      ?.map((cus: any) => ({
        ...cus,
        name: `${cus?.name}`,
      }));

    if (foundStrategies?.length === 0) {
      return [{ id: filter, name: filter }];
    }
    return foundStrategies;
  };

  return (
    <Field
      label={label}
      component={component}
      name={name}
      allowCustom
      dataItemKey={"name"}
      defaultValue={{ name: defaultValue }}
      textField={"name"}
      error={errors?.[name]}
      filterData={filterData}
      data={allStrategies}
      {...rest}
    />
  );
};
